import { useMemo } from "react";
import type { Server } from "@/app/servers/types";
import type { DataTableFacetedFilterOption } from "./servers-filters";

export function useServersFilterOptions(allServers: Server[]) {
  const statusOptions: DataTableFacetedFilterOption[] = [
    { label: "Enabled", value: "true" },
    { label: "Disabled", value: "false" },
  ];

  const typeOptions: DataTableFacetedFilterOption[] = useMemo(() => {
    const availableTypes = new Set<string>();

    for (const server of allServers) {
      availableTypes.add(server.type);
    }

    const options: DataTableFacetedFilterOption[] = [];

    if (availableTypes.has("http")) {
      options.push({ label: "HTTP", value: "http" });
    }
    if (availableTypes.has("mcp")) {
      options.push({ label: "MCP", value: "mcp" });
    }

    return options;
  }, [allServers]);

  return {
    typeOptions,
    statusOptions,
  };
}
